export function applyTheme(theme: "light" | "dark") {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
}

export const toggleTheme = (callback?: (newTheme: string) => void) => {
    const current = localStorage.getItem("theme") || "light";
    const newTheme = current === "dark" ? "light" : "dark";
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
    if (callback) callback(newTheme);
};

export function initTheme() {
    const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
    if (savedTheme) {
        applyTheme(savedTheme);
    } else {
        applyTheme("light");
    }
}